import { api } from '@creditsights/api-ui-web';

export interface GetDefaultQuestionsRequest {
  sessionId: string;
}

export const getDefaultQuestions = async (params: GetDefaultQuestionsRequest): Promise<string[]> => {
  const { data } = await api.get('/cs-genie/v1/get-default-questions', { params });

  return data?.defaultQuestions ?? [];
};
